import {Box, Text} from "@mantine/core";
import React from "react";

const NotEnoughData = () => {
    return (
        <Box
            sx={{
                height: "300px",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Text align="center">Not enough data</Text>
        </Box>
    );
};

export default NotEnoughData;
